export type ChatScope =
  | { kind: "business" }
  | { kind: "team"; salesTeamId: string }
  | { kind: "member"; memberId: string; salesTeamId: string | null };

export function scopeToParam(scope: ChatScope): string {
  if (scope.kind === "business") return "org";
  if (scope.kind === "team") return `team:${scope.salesTeamId}`;
  return `member:${scope.memberId}`;
}

export function parseScopeParam(
  raw: string | null | undefined,
  membersById: Map<string, { salesTeamId: string | null }>,
): ChatScope {
  if (!raw || raw === "org") return { kind: "business" };
  if (raw.startsWith("team:")) {
    const id = raw.slice("team:".length);
    if (id) return { kind: "team", salesTeamId: id };
  }
  if (raw.startsWith("member:")) {
    const id = raw.slice("member:".length);
    if (id) {
      const m = membersById.get(id);
      return {
        kind: "member",
        memberId: id,
        salesTeamId: m?.salesTeamId ?? null,
      };
    }
  }
  return { kind: "business" };
}

export function scopeKey(scope: ChatScope): string {
  if (scope.kind === "business") return "business";
  if (scope.kind === "team") return `team:${scope.salesTeamId}`;
  return `member:${scope.memberId}`;
}
